export enum AppActionsTypes {
  RATES = "RATES_SUCCESS",
}